import LabelManageResult from './LabelManageResult';

export default (props) => {
  return <LabelManageResult {...props} />;
};
